import { Component, signal, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DoctorProfileService } from '../core/services/doctor-profile.service';
import { User } from '../core/models/user.model';
// import 'emoji-mart';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly title = signal('med-visits-doctor');
  isMenuOpen = false;
  currentUser: User | null = null;
  passwordExpiringIn: number | null = null;

  constructor(
    private router: Router,
    private doctorProfileService: DoctorProfileService,
  ) {}

  ngOnInit(): void {
    // Only load user profile if not in prerendering
    if (typeof document !== 'undefined') {
      this.loadCurrentUser();
    }
  }

  private loadCurrentUser(): void {
    this.doctorProfileService.getUserProfile().subscribe({
      next: (user: User) => {
        this.currentUser = user;
        this.calculatePasswordExpiration();
      },
      error: (error: any) => {
        // User not logged in or error fetching profile - ignore silently
        // This is expected during prerendering or for non-authenticated users
      },
    });
  }

  private calculatePasswordExpiration(): void {
    if (!this.currentUser?.passwordExpiresAt) {
      this.passwordExpiringIn = null;
      return;
    }

    const expirationDate = new Date(this.currentUser.passwordExpiresAt);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    expirationDate.setHours(0, 0, 0, 0);

    const daysUntilExpiry = Math.ceil(
      (expirationDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24),
    );

    // Show alert if expiring in 15 days or less
    this.passwordExpiringIn = daysUntilExpiry <= 15 && daysUntilExpiry > 0 ? daysUntilExpiry : null;
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  navigateHome() {
    this.router.navigate(['/']).then((r) => {});
  }
}
